"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/portal/portal-context.tsx
var _react = require('react');
var PortalContext = _react.createContext.call(void 0, null);



exports.PortalContext = PortalContext;
